/** Routes of TwinnyX, from the app's root. */
export const TWX_SLUGS = {
    home: 'home',
    website: 'website',
    agent: 'agent',
    experience: 'experience',
    campaigns: 'campaigns',
    /** Leads, the conversations handed off to you, pipeline, calendar, tasks. */
    contacts: 'contacts',
    /** The contacts who talked to the agent, with their conversations and evaluation. */
    evaluation: 'evaluation',
    analytics: 'analytics',
    settings: 'settings',
} as const;

export type TwxSlug = (typeof TWX_SLUGS)[keyof typeof TWX_SLUGS];

/** Tabs of the website section (/website/<tab>). */
export const TWX_WEBSITE_SLUGS = {
    overview: 'overview',
    web: 'web',
    documents: 'documents',
    catalog: 'catalog',
} as const;

/** Tabs of the agent section (`/agent?tab=`; behaviour — instructions + functions — is the default). */
export const TWX_AGENT_SLUGS = {
    behavior: 'behavior',
    end: 'end',
} as const;

/** Where a tool's OAuth comes back to: `/agent/<TWX_AGENT_CONNECT>/<tool>?code=`. */
export const TWX_AGENT_CONNECT = 'connect';
